const NULL = '!n';
const TRUE = '!t';
const FALSE = '!f';
const OBJECT_START = '(';
const ARRAY_START = '!(';
const OBJECT_ARRAY_END = ')';
const COLON = ':';
const COMMA = ',';
const STRING = 'string';
const NUMBER = 'number';

export { ARRAY_START, COLON, COMMA, FALSE, NULL, NUMBER, OBJECT_ARRAY_END, OBJECT_START, STRING, TRUE };
//# sourceMappingURL=token.mjs.map
